module.exports = __webpack_public_path__ + "img/replay.9b5896b0.svg";